import { Plus } from "@gravity-ui/icons";
import { Card, Icon, Spin } from "@gravity-ui/uikit";
import { useAction, useAtom } from "@reatom/npm-react";

import { createExportTasksRequest } from "../../store/fetchers";
import css from "./NewExportTaskCard.module.scss";

export const NewExportTaskCard = () => {
  const createExportTask = useAction(createExportTasksRequest);
  const [isLoading] = useAtom(createExportTasksRequest.isLoadingAtom);

  return (
    <div onClick={() => !isLoading && createExportTask()}>
      <Card
        className={css.exportTaskCard}
        theme="normal"
        view="outlined"
        size="m"
      >
        {isLoading ? (
          <Spin />
        ) : (
          <>
            <Icon data={Plus} />
            <p>Новая выгрузка</p>
          </>
        )}
      </Card>
    </div>
  );
};
